import { Subject } from 'rxjs';
import { ChipViewModel } from './chip-view-model';
import { Blackjack } from 'game-logic';
import { GameServices } from '../../../services/game-services';

export class ChipStackViewModel {
  public get chipViewModelChanges$() {
    return this.chipViewModelChanges.asObservable();
  }

  private chipViewModels: ChipViewModel[] = [];
  private readonly chipViewModelChanges = new Subject<{
    type: 'add' | 'remove';
    viewModel: ChipViewModel;
    animated: boolean;
  }>();

  constructor(
    private gameServices: GameServices,
    private jitterSeed: number,
  ) {}

  public setJitterSeed(seed: number): void {
    this.jitterSeed = seed;
  }

  public chipStackCleared(): void {
    for (const viewModel of this.chipViewModels) {
      this.chipViewModelChanges.next({ type: 'remove', viewModel, animated: false });
    }
    this.chipViewModels = [];
  }

  public chipStackIncreased(chip: Blackjack.ChipDenomination, animated: boolean) {
    const addedChipViewModel = new ChipViewModel(
      this.gameServices,
      chip,
      this.jitterSeed + this.chipViewModels.length,
    );
    this.chipViewModels.push(addedChipViewModel);
    this.chipViewModelChanges.next({ type: 'add', viewModel: addedChipViewModel, animated });
  }
}
